
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type MediaInfoLinksItemLinkType = typeof MediaInfoLinksItemLinkType[keyof typeof MediaInfoLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaInfoLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
